import DuckEntity from './DuckEntity';
import { actionize, apiAction, apiFetch } from "../utils";
import FilteredContactList from "./FilteredContactList";

const baseEntity = new FilteredContactList(new DuckEntity('contract_fees'));

const contractFeeActivateTypes = actionize({
  CONTRACT_FEE_ACTIVATE_BEGIN: null,
  CONTRACT_FEE_ACTIVATE_SUCCESS: null,
  CONTRACT_FEE_ACTIVATE_ERROR: null
}, action => `schooladmin/actions/${action}`);

const activate = (id) => apiAction(
  contractFeeActivateTypes.CONTRACT_FEE_ACTIVATE_BEGIN,
  contractFeeActivateTypes.CONTRACT_FEE_ACTIVATE_SUCCESS,
  contractFeeActivateTypes.CONTRACT_FEE_ACTIVATE_ERROR,
  (state) => apiFetch.put(state, `contract_fees/${id}/activate`)
);

const contractFeeDeactivateTypes = actionize({
  CONTRACT_FEE_DEACTIVATE_BEGIN: null,
  CONTRACT_FEE_DEACTIVATE_SUCCESS: null,
  CONTRACT_FEE_DEACTIVATE_ERROR: null
}, action => `schooladmin/actions/${action}`);

const deactivate = (id) => {
  return apiAction(
    contractFeeDeactivateTypes.CONTRACT_FEE_DEACTIVATE_BEGIN,
    contractFeeDeactivateTypes.CONTRACT_FEE_DEACTIVATE_SUCCESS,
    contractFeeDeactivateTypes.CONTRACT_FEE_DEACTIVATE_ERROR,
    (state) => apiFetch.put(state, `contract_fees/${id}/deactivate`)
  );
};

export default baseEntity.reducer;

export const entity = {
  ...baseEntity,
  actions: {
    ...baseEntity.actions,
    activate,
    deactivate
  }
};